import React, { useEffect, useState } from "react";
import { Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth, db } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { doc, getDoc } from "firebase/firestore";
import logo from "../assets/OSM-logo.png";

const baseNavigation = [
    { name: "Dashboard", href: "/dashboard" },
    { name: "Woning toevoegen", href: "/dashboard/add" },
    { name: "Mijn woningen", href: "/dashboard/properties" },
    { name: "Profiel", href: "/dashboard/profile" },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const DashboardLayout = ({ children }) => {
    const [user] = useAuthState(auth);
    // const [isAdmin, setIsAdmin] = useState(false);

    // useEffect(() => {
    //     const fetchUser = async () => {
    //         if (user) {
    //             const ref = doc(db, "users", user.uid);
    //             const snap = await getDoc(ref);
    //             if (snap.exists() && snap.data().isAdmin === true) {
    //                 setIsAdmin(true);
    //             }
    //         }
    //     };
    //     fetchUser();
    // }, [user]);

    const navigation = baseNavigation;


    return (
        <div className="min-h-screen bg-gray-100">
            <Disclosure as="nav" className="bg-white shadow">
                {({ open }) => (
                    <>
                        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                            <div className="flex h-16 justify-between items-center">
                                {/* Logo */}
                                <div className="flex items-center">
                                    <img src={logo} alt="Logo" className="h-8 w-auto" />
                                </div>

                                {/* Desktop nav */}
                                <div className="hidden sm:flex sm:items-center sm:space-x-6">
                                    {navigation.map((item) => (
                                        <Link
                                            key={item.name}
                                            to={item.href}
                                            className="text-gray-700 hover:text-blue-600 text-sm font-medium"
                                        >
                                            {item.name}
                                        </Link>
                                    ))}
                                    <button
                                        onClick={() => signOut(auth)}
                                        className="text-gray-600 hover:text-red-500 text-sm"
                                        title="Uitloggen"
                                    >
                                        🔒
                                    </button>
                                </div>

                                {/* Mobile menu button */}
                                <div className="sm:hidden flex items-center">
                                    <Disclosure.Button className="inline-flex items-center justify-center p-2 text-gray-500 hover:text-black hover:bg-gray-100 rounded focus:outline-none">
                                        <span className="sr-only">Open menu</span>
                                        {open ? (
                                            <XMarkIcon className="block h-6 w-6" />
                                        ) : (
                                            <Bars3Icon className="block h-6 w-6" />
                                        )}
                                    </Disclosure.Button>
                                </div>
                            </div>
                        </div>

                        {/* Mobile nav */}
                        <Disclosure.Panel className="sm:hidden">
                            <div className="space-y-1 px-4 pt-2 pb-3">
                                {navigation.map((item) => (
                                    <Link
                                        key={item.name}
                                        to={item.href}
                                        className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100"
                                    >
                                        {item.name}
                                    </Link>
                                ))}
                                <button
                                    onClick={() => signOut(auth)}
                                    className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-red-500 hover:bg-gray-100"
                                >
                                    🔒 Uitloggen
                                </button>
                            </div>
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>

            <main className="p-6">{children}</main>
        </div>
    );
};

export default DashboardLayout;
